// FDDWorkflow.jsx
import React from 'react';
import { Box } from '@mui/material';
import Header from '../Header';
import ChillerBar from './SubPages/ChillerBar';
import Content from './SubPages/Content';

const Fdd_App = () => (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <Header name="FDD Workflow Logs" />
      <Box
        sx={{
          marginLeft: "2rem",
          marginTop: "1.5rem",
          width: "95%",
          height:"4rem",
          backgroundColor:"white",
          flex: 0,
          py: 0,
          px: 2,
          boxShadow: "rgb(87 99 113 / 15%) 4px 4px 5px 2px",
          borderRadius: "12px",
        }}
      >
        <ChillerBar />
      </Box>

      <Box sx={{flex: 1, py: 3, px: 5 }}>
        <Content />
      </Box>
    </Box>
);

export default Fdd_App;
